import Vue from "vue";
import Router from "vue-router";
import store from "./store";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	routes: [
		{
			path: "/login",
			name: "login",
			component: () =>
				import(/* webpackChunkName: "login" */ "./views/Login.vue")
		},
		{
			path: "/en/login",
			name: "en_login",
			component: () =>
				import(/* webpackChunkName: "login" */ "./views/Login.vue")
		},
		{
			path: "/forget",
			name: "forget",
			component: () =>
				import(/* webpackChunkName: "forgetPassword" */ "./views/ForgetPassword.vue")
		},
		{
			path: "/en/forget",
			name: "en_forget",
			component: () =>
				import(/* webpackChunkName: "forgetPassword" */ "./views/ForgetPassword.vue")
		},
		{
			path: "/reset",
			name: "reset",
			component: () =>
				import(/* webpackChunkName: "resetPassword" */ "./views/ResetPassword.vue")
		},
		{
			path: "/en/reset",
			name: "en_reset",
			component: () =>
				import(/* webpackChunkName: "resetPassword" */ "./views/ResetPassword.vue")
		},
		{
			path: "/protocol",
			name: "protocol",
			component: () =>
				import(/* webpackChunkName: "protocol" */ "./views/Protocol.vue")
		},
		{
			path: "/en/protocol",
			name: "en_protocol",
			component: () =>
				import(/* webpackChunkName: "protocol" */ "./views/Protocol.vue")
		},
		{
			path: "/information",
			name: "information",
			component: () =>
				import(/* webpackChunkName: "information" */ "./views/Information.vue")
		},
		{
			path: "/en/information",
			name: "en_information",
			component: () =>
				import(/* webpackChunkName: "information" */ "./views/Information.vue")
		},
		{
			path: "/activity",
			name: "activity",
			component: () =>
				import(/* webpackChunkName: "activity" */ "./views/Activity.vue")
		},
		{
			path: "/en/activity",
			name: "en_activity",
			component: () =>
				import(/* webpackChunkName: "activity" */ "./views/Activity.vue")
		},
		{
			path: "/hotel",
			name: "hotel",
			component: () =>
				import(/* webpackChunkName: "hotel" */ "./views/Hotel.vue")
		},
		{
			path: "/en/hotel",
			name: "en_hotel",
			component: () =>
				import(/* webpackChunkName: "hotel" */ "./views/Hotel.vue")
		},
		{
			path: "/flight",
			name: "flight",
			component: () =>
				import(/* webpackChunkName: "flight" */ "./views/Flight.vue")
		},
		{
			path: "/en/flight",
			name: "en_flight",
			component: () =>
				import(/* webpackChunkName: "flight" */ "./views/Flight.vue")
		},
		{
			path: "/regSuccess",
			name: "regSuccess",
			component: () =>
				import(/* webpackChunkName: "document" */ "./views/ResSuccess.vue")
		},
		{
			path: "/en/regSuccess",
			name: "en_regSuccess",
			component: () =>
				import(/* webpackChunkName: "document" */ "./views/ResSuccess.vue")
		},
		{
			path: "/document",
			name: "document",
			component: () =>
				import(/* webpackChunkName: "document" */ "./views/Document.vue")
		},
		{
			path: "/en/document",
			name: "en_document",
			component: () =>
				import(/* webpackChunkName: "document" */ "./views/Document.vue")
		},
		{
			path: "/summary",
			name: "summary",
			component: () =>
				import(/* webpackChunkName: "summary" */ "./views/Summary.vue")
		},
		{
			path: "/en/summary",
			name: "en_summary",
			component: () =>
				import(/* webpackChunkName: "summary" */ "./views/Summary.vue")
		}
	]
});

router.beforeEach((to, from, next) => {
	// 切换语言
	if (to.name && to.name.indexOf('en_') !== -1) {
		// 去英文版
		store.dispatch('main/changeLanguage', 'en');
	} else {
		// 去中文版
		store.dispatch('main/changeLanguage', 'zh');
	}

	// 公开页面列表（不需要登录）
	const publicPages = ['login', 'en_login', 'forget', 'en_forget', 'reset', 'en_reset'];

	// 如果是公开页面，直接放行
	if (publicPages.includes(to.name)) {
		next();
		return;
	}

	// 如果已经有用户ID，直接放行
	if (store.state.main.currentUser.user_id) {
		next();
		return;
	}

	// 没有用户信息，跳转到登录页
	const language = store.state.main.language;
	if (language === 'zh') {
		next('/login');
	} else {
		next('/en/login');
	}
});

export default router;
